import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (store.getters['auth/loggedIn']) {
      //     // Redirect to the home page instead
      //     next({ name: 'default' })
      //   } else {
      //     // Continue to the login page
      //     next()
      //   }
      // },
    },
    beforeEnter(to, from, next) {
      const logged = store.state.authBackend.status.loggeduser;
      if ( logged ){
         next({
           path: '/',
           replace: true
         })
      } else {
         next()
      }
    }
  },
  {
    path: '/auth/two-factor/verify',
    name: 'verify-otp',
    meta: { authRequired: false },
    component: () => import('./views/account/verify-otp')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('authBackend/logout')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        console.log('route form ', routeFrom);
        console.log('auth req prev ', authRequiredOnPreviousRoute);
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
        // next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '/403',
    name: '403',
    component: require('./views/utility/403').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/malware',
    name: 'malware',
    meta: { authRequired: true },
    component: () => import('./views/malware/malware')
  },
  {
    path: '/malware2',
    name: 'malware2',
    meta: { authRequired: true },
    component: () => import('./views/malware/malware2')
  },
  {
    path: '/malware/setting',
    name: 'malware-setting',
    meta: { authRequired: true },
    component: () => import('./views/preference/setting')
  },
  {
    path: '/malware/detail',
    name: 'malware-detail',
    meta: { authRequired: true },
    component: () => import('./views/malware/detail-malware'),
  },
  {
    path: '/malware/user',
    name: 'malware-user',
    meta: { authRequired: true },
    component: () => import('./views/malware/users'),
    beforeEnter(to, from, next) {
      const role = store.state.authBackend.role;
      if ( role != 'admn' ){
         next({
           path: '403',
           replace: true
         })
      } else {
         next()
      }
    }
  },
  {
    path: '/malware/user/detail',
    name: 'detail-user',
    meta: { authRequired: true },
    component: () => import('./views/malware/users-detail'),
    beforeEnter(to, from, next) {
      const id = to.query.id;
      if ( id === undefined || id == '' ){
         next({
           path: '404',
           replace: true
         })
      } else {
         next()
      }
    }
  },
  {
    path: '/malware/report-analysis',
    name: 'malware-report-analysis',
    meta: { authRequired: true },
    component: () => import('./views/malware/report-analysis')
  },
  {
    path: '/malware/detail-report',
    name: 'detail-malware-report',
    meta: { authRequired: true },
    component: () => import('./views/malware/report-detail')
  },
  {
    path: '/malware/create-report',
    name: 'malware-create-report',
    meta: { authRequired: true },
    component: () => import('./views/malware/create-report'),
    beforeEnter(to, from, next) {
      const role = store.state.authBackend.role;
      if ( role == 'verf' ){
         next({
           path: '403',
           replace: true
         })
      } else {
         next()
      }
    }
  },
  {
    path: '/dashboard/saas',
    name: 'saas-dashboard',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/saas/index')
  },
  {
    path: '/dashboard/crypto',
    name: 'crypto-dashboard',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/crypto/index')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { authRequired: true },
    component: () => import('./views/contacts/contacts-profile')
  },
  {
    path: '/profile/update',
    name: 'Profile-update',
    meta: { authRequired: true },
    component: () => import('./views/contacts/contacts-profile-update')
  },
  {
    path: '/profile/setting',
    name: 'Profile-setting',
    meta: { authRequired: true },
    component: () => import('./views/contacts/contacts-profile-setting')
  },

  {
    path: '/profile/setting/two-step-verification',
    name: 'Profile-setting/two-step-verification',
    meta: { authRequired: true },
    component: () => import('./views/contacts/two-step-verification')
  },

  {
    path: '/profile/setting/two-step-verification/auth-app',
    name: 'Profile-setting/two-step-verification/auth-app',
    meta: { authRequired: true },
    component: () => import('./views/contacts/auth-app')
  },

  {
    path: '/profile/change-password',
    name: 'Profile-change-password',
    meta: { authRequired: true },
    component: () => import('./views/contacts/contacts-change-password')
  },
  {
    path: '/pages/404',
    name: 'Error-404',
    meta: { authRequired: true },
    component: () => import('./views/utility/404')
  },
  {
    path: '/pages/403',
    name: 'Error-403',
    meta: { authRequired: true },
    component: () => import('./views/utility/404')
  },
  {
    path: '/pages/500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () => import('./views/utility/500')
  },
]
